import React from "react";
import { useHistory } from "react-router-dom";
import "../../styles/OrderStatusPopup.css";

interface OrderStatusPopupProps {
  status: "success" | "failure";
  message: string;
  show: boolean;
  onClose: () => void;
}

const OrderStatusPopup: React.FC<OrderStatusPopupProps> = ({
  status,
  message,
  show = true,
  onClose,
}) => {
  const history = useHistory();

  if (!show) return null;

  const handleSuccessViewOrder = () => {
    history.push("/delivery-orders");
    onClose();
  };

  const handleFailureReturnHome = () => {
    onClose(); // Reset to Step 1 in Stepper
  };

  return (
    <div className="popup-overlay">
      <div className={`popup-container ${status}`}>
        <div className="popup-icon-container">
          {status === "success" ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="100"
              height="100"
              viewBox="0,0,256,256"
            >
              <g
                fill="none"
                fill-rule="nonzero"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray=""
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                // style="mix-blend-mode: normal"
              >
                <g transform="scale(2.56,2.56)">
                  <path
                    d="M50,13c-20.43454,0 -37,16.56546 -37,37c0,20.43454 16.56546,37 37,37c20.43454,0 37,-16.56546 37,-37c0,-20.43454 -16.56546,-37 -37,-37z"
                    fill="#302050"
                  ></path>
                  <path
                    d="M13,27c-1.10457,0 -2,0.89543 -2,2c0,1.10457 0.89543,2 2,2c1.10457,0 2,-0.89543 2,-2c0,-1.10457 -0.89543,-2 -2,-2z"
                    fill="#99834d"
                  ></path>
                  <path
                    d="M77,12c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1zM83,11c-2.20914,0 -4,1.79086 -4,4c0,2.20914 1.79086,4 4,4c2.20914,0 4,-1.79086 4,-4c0,-2.20914 -1.79086,-4 -4,-4z"
                    fill="#b09952"
                  ></path>
                  <path
                    d="M87,22c-1.10457,0 -2,0.89543 -2,2c0,1.10457 0.89543,2 2,2c1.10457,0 2,-0.89543 2,-2c0,-1.10457 -0.89543,-2 -2,-2z"
                    fill="#99834d"
                  ></path>
                  <path
                    d="M81,74c-1.10457,0 -2,0.89543 -2,2c0,1.10457 0.89543,2 2,2c1.10457,0 2,-0.89543 2,-2c0,-1.10457 -0.89543,-2 -2,-2zM15,59c-2.20914,0 -4,1.79086 -4,4c0,2.20914 1.79086,4 4,4c2.20914,0 4,-1.79086 4,-4c0,-2.20914 -1.79086,-4 -4,-4z"
                    fill="#b09952"
                  ></path>
                  <path
                    d="M25,85c-1.10457,0 -2,0.89543 -2,2c0,1.10457 0.89543,2 2,2c1.10457,0 2,-0.89543 2,-2c0,-1.10457 -0.89543,-2 -2,-2z"
                    fill="#99834d"
                  ></path>
                  <path
                    d="M18.5,51c-1.38071,0 -2.5,1.11929 -2.5,2.5c0,1.38071 1.11929,2.5 2.5,2.5c1.38071,0 2.5,-1.11929 2.5,-2.5c0,-1.38071 -1.11929,-2.5 -2.5,-2.5z"
                    fill="#ffffff"
                  ></path>
                  <path
                    d="M21,66c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1z"
                    fill="#b09952"
                  ></path>
                  <path
                    d="M80,33c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1z"
                    fill="#ffffff"
                  ></path>
                  <g>
                    <path
                      d="M50,26.042c-13.23164,0 -23.958,10.72636 -23.958,23.958c0,13.23164 10.72636,23.958 23.958,23.958c13.23164,0 23.958,-10.72636 23.958,-23.958c0,-13.23164 -10.72636,-23.958 -23.958,-23.958z"
                      fill="#99834d"
                    ></path>
                    <path
                      d="M50,26.4c13.013,0 23.6,10.587 23.6,23.6c0,13.013 -10.587,23.6 -23.6,23.6c-13.013,0 -23.6,-10.587 -23.6,-23.6c0,-13.013 10.587,-23.6 23.6,-23.6M50,25c-13.807,0 -25,11.193 -25,25c0,13.807 11.193,25 25,25c13.807,0 25,-11.193 25,-25c0,-13.807 -11.193,-25 -25,-25z"
                      fill="#472b29"
                    ></path>
                    <path
                      d="M50,30.5c-10.76955,0 -19.5,8.73045 -19.5,19.5c0,10.76955 8.73045,19.5 19.5,19.5c10.76955,0 19.5,-8.73045 19.5,-19.5c0,-10.76955 -8.73045,-19.5 -19.5,-19.5z"
                      fill="#fdfcef"
                    ></path>
                    <path
                      d="M69.762,46.954c-0.043,-0.273 -0.298,-0.46 -0.571,-0.418c-0.273,0.042 -0.461,0.297 -0.417,0.571c0.931,5.976 -1.054,12.082 -5.309,16.334c-7.417,7.412 -19.485,7.412 -26.902,0c-7.417,-7.411 -7.417,-19.471 0,-26.883c7.417,-7.411 19.485,-7.411 26.902,0c0.778,0.778 1.493,1.642 2.186,2.641c0.158,0.227 0.469,0.284 0.697,0.126c0.225,-0.155 0.283,-0.468 0.126,-0.696c-0.728,-1.049 -1.481,-1.958 -2.302,-2.778c-7.807,-7.801 -20.51,-7.802 -28.318,0c-7.807,7.802 -7.807,20.496 0,28.298c7.807,7.801 20.51,7.802 28.318,0c4.481,-4.477 6.571,-10.905 5.59,-17.195z"
                      fill="#472b29"
                    ></path>
                    <path
                      d="M67.569,42.796c0.105,0.256 0.398,0.378 0.653,0.273c0.254,-0.104 0.378,-0.396 0.272,-0.652c-0.315,-0.766 -0.609,-1.395 -0.926,-1.977c-0.132,-0.243 -0.436,-0.332 -0.679,-0.2c-0.043,0.023 -0.082,0.053 -0.115,0.086c-0.153,0.153 -0.194,0.393 -0.086,0.593c0.301,0.549 0.581,1.146 0.881,1.877z"
                      fill="#472b29"
                    ></path>
                  </g>
                  <g>
                    <path
                      d="M41,48.375c-0.434,0 -0.842,0.169 -1.149,0.476c-0.307,0.307 -0.476,0.715 -0.476,1.149c0,0.434 0.169,0.842 0.476,1.149l7,7c0.307,0.307 0.715,0.476 1.149,0.476v0.375l0.031,-0.375c0.445,-0.009 0.869,-0.201 1.167,-0.526l11,-12c0.293,-0.32 0.444,-0.735 0.426,-1.169c-0.019,-0.434 -0.206,-0.833 -0.525,-1.127c-0.321,-0.293 -0.728,-0.45 -1.169,-0.426c-0.433,0.019 -0.833,0.205 -1.126,0.525l-9.854,10.749l-5.8,-5.8c-0.308,-0.307 -0.716,-0.476 -1.15,-0.476z"
                      fill="#99834d"
                    ></path>
                    <path
                      d="M59,43.75v0c0.313,0 0.613,0.117 0.845,0.329c0.246,0.226 0.389,0.533 0.404,0.867c0.014,0.334 -0.102,0.653 -0.328,0.899l-11,12c-0.229,0.25 -0.555,0.398 -0.921,0.405c-0.334,0 -0.648,-0.13 -0.884,-0.366l-7,-7c-0.236,-0.236 -0.366,-0.55 -0.366,-0.884c0,-0.334 0.13,-0.648 0.367,-0.884c0.235,-0.236 0.549,-0.366 0.883,-0.366c0.334,0 0.648,0.13 0.884,0.366l5.523,5.523l0.554,0.554l0.529,-0.577l9.589,-10.461c0.239,-0.261 0.566,-0.405 0.921,-0.405M59,43c-0.541,0 -1.08,0.218 -1.474,0.649l-9.589,10.46l-5.523,-5.523c-0.39,-0.391 -0.902,-0.586 -1.414,-0.586c-0.512,0 -1.024,0.195 -1.414,0.586c-0.781,0.781 -0.781,2.047 0,2.828l7,7c0.375,0.376 0.884,0.586 1.414,0.586c0.015,0 0.029,0 0.043,0c0.545,-0.012 1.062,-0.246 1.431,-0.648l11,-12c0.747,-0.814 0.691,-2.08 -0.123,-2.826c-0.384,-0.352 -0.868,-0.526 -1.351,-0.526z"
                      fill="#472b29"
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="100"
              height="100"
              viewBox="0 0 100 100"
            >
              <path
                fill="#ee3e54"
                d="M13 27A2 2 0 1 0 13 31A2 2 0 1 0 13 27Z"
              ></path>
              <path
                fill="#f1bc19"
                d="M77 12A1 1 0 1 0 77 14A1 1 0 1 0 77 12Z"
              ></path>
              <path
                fill="#f9dbd2"
                d="M50 13A37 37 0 1 0 50 87A37 37 0 1 0 50 13Z"
              ></path>
              <path
                fill="#f1bc19"
                d="M83 11A4 4 0 1 0 83 19A4 4 0 1 0 83 11Z"
              ></path>
              <path
                fill="#ee3e54"
                d="M87 22A2 2 0 1 0 87 26A2 2 0 1 0 87 22Z"
              ></path>
              <path
                fill="#fbcd59"
                d="M81 74A2 2 0 1 0 81 78 2 2 0 1 0 81 74zM15 59A4 4 0 1 0 15 67 4 4 0 1 0 15 59z"
              ></path>
              <path
                fill="#ee3e54"
                d="M25 85A2 2 0 1 0 25 89A2 2 0 1 0 25 85Z"
              ></path>
              <path
                fill="#fff"
                d="M18.5 51A2.5 2.5 0 1 0 18.5 56A2.5 2.5 0 1 0 18.5 51Z"
              ></path>
              <path
                fill="#f1bc19"
                d="M21 66A1 1 0 1 0 21 68A1 1 0 1 0 21 66Z"
              ></path>
              <path
                fill="#fff"
                d="M80 33A1 1 0 1 0 80 35A1 1 0 1 0 80 33Z"
              ></path>
              <g>
                <path
                  fill="#fdfcee"
                  d="M50 26A24 24 0 1 0 50 74A24 24 0 1 0 50 26Z"
                ></path>
                <path
                  fill="#472b29"
                  d="M50,26.4C63,26.4,73.6,37,73.6,50S63,73.6,50,73.6S26.4,63,26.4,50S37,26.4,50,26.4 M50,25 c-13.8,0-25,11.2-25,25s11.2,25,25,25s25-11.2,25-25S63.8,25,50,25L50,25z"
                ></path>
                <path
                  fill="#ee3e54"
                  d="M50 30.4A19.6 19.6 0 1 0 50 69.6A19.6 19.6 0 1 0 50 30.4Z"
                ></path>
                <path
                  fill="#f06272"
                  d="M50,33.4c10.3,0,18.8,8,19.5,18.1c0-0.5,0.1-1,0.1-1.5c0-10.8-8.8-19.6-19.6-19.6S30.4,39.2,30.4,50 c0,0.5,0,1,0.1,1.5C31.2,41.4,39.7,33.4,50,33.4z"
                ></path>
                <path
                  fill="#472b29"
                  d="M50,30.8c10.6,0,19.3,8.6,19.3,19.2c0,10.6-8.6,19.3-19.3,19.3c-10.6,0-19.2-8.6-19.2-19.3 C30.8,39.4,39.4,30.8,50,30.8 M50,30c-11,0-20,9-20,20c0,11,9,20,20,20c11,0,20-9,20-20S61,30,50,30L50,30z"
                ></path>
              </g>
              <g>
                <path
                  fill="#fdfcee"
                  d="M52.3,50l5.9-5.9c0.3-0.3,0.5-0.7,0.5-1.1s-0.2-0.8-0.5-1.1c-0.6-0.6-1.7-0.6-2.3,0L50,47.7 l-5.9-5.9c-0.6-0.6-1.7-0.6-2.3,0c-0.6,0.6-0.6,1.7,0,2.3l5.9,5.9l-5.9,5.9c-0.6,0.6-0.6,1.7,0,2.3c0.6,0.6,1.7,0.6,2.3,0l5.9-5.9 l5.9,5.9c0.3,0.3,0.7,0.5,1.1,0.5s0.8-0.2,1.1-0.5c0.6-0.6,0.6-1.7,0-2.3L52.3,50z"
                ></path>
                <path
                  fill="#472b29"
                  d="M43,59c-0.5,0-1-0.2-1.4-0.6c-0.8-0.8-0.8-2,0-2.8l5.6-5.6l-5.6-5.6C41.2,44,41,43.5,41,43 s0.2-1,0.6-1.4c0.8-0.8,2.1-0.8,2.8,0l5.6,5.6l5.6-5.6c0.8-0.8,2-0.8,2.8,0C58.8,42,59,42.5,59,43s-0.2,1-0.6,1.4L52.8,50l5.6,5.6 c0.8,0.8,0.8,2,0,2.8c-0.8,0.8-2.1,0.8-2.8,0L50,52.8l-5.6,5.6C44,58.8,43.5,59,43,59z M43,41.7c-0.3,0-0.6,0.1-0.9,0.4 c-0.2,0.2-0.4,0.5-0.4,0.9s0.1,0.6,0.4,0.9l6.1,6.1l-6.1,6.1c-0.5,0.5-0.5,1.3,0,1.8c0.5,0.5,1.3,0.5,1.8,0l6.1-6.1l6.1,6.1 c0.5,0.5,1.3,0.5,1.8,0c0.5-0.5,0.5-1.3,0-1.8L51.8,50l6.1-6.1c0.2-0.2,0.4-0.6,0.4-0.9s-0.1-0.6-0.4-0.9c-0.5-0.5-1.3-0.5-1.8,0 L50,48.2l-6.1-6.1C43.6,41.9,43.3,41.7,43,41.7z"
                ></path>
              </g>
            </svg>
          )}
        </div>

        <h2 className="popup-title">
          {status === "success" ? "Order Placed!" : "Order Failed!"}
        </h2>
        <p className="popup-message">{message}</p>

        <div className="popup-buttons">
          {status === "success" ? (
            <button
              className="popup-button success"
              onClick={handleSuccessViewOrder}
            >
              View Order
            </button>
          ) : (
            <button
              className="popup-button failure"
              onClick={handleFailureReturnHome}
            >
              Return Home
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderStatusPopup;
